function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHighLatency = function SvgHighLatency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24mm",
    height: "24mm",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.215221,
      fill: "currentColor"
    },
    stroke: "currentColor",
    d: "M21.258.741h6.37v30.731h-6.37zM12.62 14.768h6.37v16.725h-6.37zM4.096 20.921h6.37v10.592h-6.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.215221,
      fill: "currentColor"
    },
    stroke: "currentColor",
    d: "M3.15 4.283 5.404.335 7.66-3.612 9.95.315l2.291 3.927-4.546.02Z",
    transform: "matrix(1.48782 0 0 1.70902 -4.284 6.537)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.55448 0 0 .64473 -19.472 -6.704)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45,
    y: 29
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#fff"
    }
  }, "!"))));
};
export default SvgHighLatency;